import { getAnalyticsUserId } from '@odmonorepo/odfunctions';
import { v4 as uuidv4 } from 'uuid';

/**
 * Headers attached to every outbound API call so a single request can be correlated across
 * Datadog RUM/FullStory sessions in the browser and CloudWatch logs on the backend.
 * - `X-Request-Id`: unique per call, lets a single network request be found in backend logs.
 * - `X-Analytics-Id`: the same anonymous/user id used to identify the browser session with
 *   Adobe/Datadog/FullStory, so a support engineer can pivot from a session replay to logs.
 */
export const getTracingHeaders = (): Record<string, string> => ({
  'X-Request-Id': uuidv4(),
  'X-Analytics-Id': getAnalyticsUserId(),
});
